export default __webpack_public_path__ + "static/media/ico_app_gray.7ae2b98b.svg";